<div mat-dialog-content id="certification-configuration-certificate-modal"
     *ngIf="data.isCertificationConfigurationCertificate">
    <button mat-raised-button class="close-button" (click)="onClose()">
        <mat-icon>close</mat-icon>
    </button>
    <p class="center">{{data.certificationAuthorityCertificate}}</p>
</div>

